import React, { Fragment } from 'react';
import BlockNumber from '../Components/BlockNumber';
import Muted from '../Components/Muted';
import AddressName from '../Components/AddressName';
import Coin from '../Components/Coin';
import EtherscanLink from '../Components/EtherscanLink';

export default class TransactionRow extends React.PureComponent {
  render () {
    const transactionEvent = this.props.transaction;

    return (
      <Fragment>
        <BlockNumber blockNumber={transactionEvent.blockNumber}/>
        <Muted content="from&nbsp;"/>
        <AddressName address={transactionEvent.args.from.toString()}/>
        <Muted content="to&nbsp;"/>
        <AddressName address={transactionEvent.args.to.toString()}/>
        <Coin coin={transactionEvent.args.tokens.toNumber()}/>
        <EtherscanLink txHash={transactionEvent.transactionHash}/>
      </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/AnalyticsPage/TransactionRow.js